module.exports = __webpack_public_path__ + "img/marmore_contorno.edb514cd.png";